import styled from 'styled-components';
export const StyledSuperOddsHeading = styled.div`
  background-color: ${(props) => props.theme.superOdds_heading_BG} !important;
  color: ${(props) => props.theme.superOdds_heading_text} !important;
`;

export const StyledSuperOdds = styled.button`
    background-color: ${(props) => props.selected ? props.theme.superOddSelected_BG : props.theme.superOdds_BG} !important;
    color: ${(props) => props.selected ? props.theme.superOddSeleted_text : props.theme.superOdds_text} !important;
    border: 1px solid ${(props) => props.selected ? props.theme.superOddSelected_BG : props.theme.superOdds_BG} !important;
  @media (max-width: 580px) {
    &:hover {
      background-color: ${(props) => props.theme.superOddSelected_BG};
      color: ${(props) => props.theme.superOddSeleted_text};
      border: 1px solid ${(props) => props.theme.superOddSelected_BG};
    }
  }
  @media (min-width: 580px) {
    &:hover {
      background-color: ${(props) => props.theme.superOddSelected_BG} !important;
      color: ${(props) => props.theme.superOddSeleted_text} !important;
      border: 1px solid ${(props) => props.theme.superOddSelected_BG} !important;
    }
  }
`;

export const StyledSuperOddsTableHeading = styled.div`
  background-color: ${(props) => props.theme.superOddsTableHeading_BG} !important;
  color: ${(props) => props.theme.superOddsTableHeading_text} !important;
`;

export const StyledSuperOddsContrainer = styled.div`
  .splide__pagination__page.is-active {
    background: ${(props) => props.theme.superOddsSplide__pagination} !important;
}
`;